"use strict";
// Carte « Luxe à travers le monde ».
// Points = villes des commandes (mises à jour automatiquement) + villes saisies dans l'éditeur.
// Les villes proches se regroupent en un point qui additionne leurs commandes ; en zoomant, elles se séparent.
(function () {
  const el = document.querySelector("[data-luxe-map]");
  if (!el || typeof L === "undefined") return;

  const lire = (sel) => { try { return JSON.parse(document.querySelector(sel).textContent); } catch (e) { return []; } };
  const cle = (s) => String(s).split(",")[0].normalize("NFKD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]/g, "");

  // fusion : les villes des commandes d'abord (compteurs à jour), puis celles de l'éditeur qui manquent
  const vus = new Set(), villes = [];
  [...lire("[data-luxe-map-auto]"), ...lire("[data-luxe-map-points]")].forEach((p) => {
    const lat = Number(String(p.lat).replace(",", ".")), lng = Number(String(p.lng).replace(",", "."));
    if (isNaN(lat) || isNaN(lng) || lat < -90 || lat > 90 || lng < -180 || lng > 180) return; // ligne invalide ignorée
    const k = cle(p.label);
    if (vus.has(k)) return;
    vus.add(k);
    villes.push({ label: String(p.label || ""), lat, lng, n: Math.max(1, parseInt(p.n, 10) || 1) });
  });

  const mobile = L.Browser.mobile;
  // Sur téléphone, un doigt fait défiler la page ; la carte se déplace et zoome à deux doigts.
  // carte : zoom aussi à la molette, au pavé tactile et en pinçant (en plus des boutons + et −)
  const map = L.map(el, { scrollWheelZoom: false, touchZoom: true, doubleClickZoom: true,
    dragging: !mobile, tap: !mobile, zoomSnap: 0, zoomDelta: 1, worldCopyJump: true }).setView([46.5, 2.5], 5);

  // Zoom à la molette / au pavé tactile / au pincement (réglé à la main : le zoom intégré était trop lent au pavé tactile)
  //  - pincement à deux doigts (pavé ou écran tactile) : le navigateur envoie « Ctrl + molette » avec de petits pas
  //  - glissement à deux doigts sur le pavé : petits pas sans Ctrl
  //  - souris : gros pas (≈ 100 px par cran) → environ un niveau de zoom par cran
  let pas = 0, ancre = null, prevu = false;
  el.addEventListener("wheel", (e) => {
    e.preventDefault();
    const d = e.deltaY * (e.deltaMode === 1 ? 33 : e.deltaMode === 2 ? 400 : 1);
    const vitesse = e.ctrlKey ? 0.035 : Math.abs(d) >= 60 ? 0.009 : 0.022;
    pas -= d * vitesse;
    ancre = map.mouseEventToContainerPoint(e);
    if (!prevu) {
      prevu = true;
      requestAnimationFrame(() => {
        prevu = false;
        const z = Math.max(map.getMinZoom(), Math.min(18, map.getZoom() + pas));
        pas = 0;
        map.setZoomAround(ancre, z, { animate: false });
      });
    }
  }, { passive: false });
  if (mobile) {
    el.addEventListener("touchstart", (e) => { if (e.touches.length > 1) map.dragging.enable(); });
    el.addEventListener("touchend", (e) => { if (e.touches.length < 2) map.dragging.disable(); });
  }
  const url = el.dataset.tiles || "https://tile.openstreetmap.org/{z}/{x}/{y}.png";
  L.tileLayer(url, { maxZoom: 19, attribution: el.dataset.attribution || "© OpenStreetMap" }).addTo(map);
  // crédit : sans « Leaflet », replié en petit « i » 5 s après l'ouverture (OSM exige qu'il soit visible au chargement)
  map.attributionControl.setPrefix(false);
  const credit = map.attributionControl.getContainer();
  credit.classList.add("lx-credit");
  credit.setAttribute("tabindex", "0");
  setTimeout(() => credit.classList.add("replie"), 5000);

  // un point doré : plus il y a de commandes, plus il est gros, avec une couronne de petits points (un par commande)
  const iconPour = (n) => {
    const taille = Math.min(14 + Math.sqrt(n - 1) * 7, 46), cour = taille / 2 + 9, sats = Math.min(n, 28);
    let h = '<div class="lx-pin" style="width:' + taille.toFixed(0) + 'px;height:' + taille.toFixed(0) + 'px">' + (n > 1 ? "<b>" + n + "</b>" : "") + "</div>";
    if (n > 1) for (let k = 0; k < sats; k++) {
      const a = (k / sats) * Math.PI * 2 - Math.PI / 2;
      h += '<i class="lx-sat" style="left:' + (cour * Math.cos(a)).toFixed(1) + "px;top:" + (cour * Math.sin(a)).toFixed(1) + "px;animation-delay:" + (k * 0.1).toFixed(2) + 's"></i>';
    }
    return L.divIcon({ className: "luxe-gold", html: '<div class="lx-mark">' + h + "</div>", iconSize: [0, 0], iconAnchor: [0, 0] });
  };

  // regroupement selon le zoom : deux villes à moins de RAYON pixels l'une de l'autre fusionnent et additionnent leurs commandes
  const RAYON = 46;
  const calque = L.layerGroup().addTo(map);
  const dessiner = () => {
    calque.clearLayers();
    const groupes = [];
    villes.slice().sort((a, b) => b.n - a.n).forEach((v) => {
      const pt = map.latLngToLayerPoint([v.lat, v.lng]);
      const g = groupes.find((x) => x.pt.distanceTo(pt) < RAYON);
      if (g) { g.villes.push(v); g.n += v.n; }
      else groupes.push({ pt, villes: [v], n: v.n });
    });
    groupes.forEach((g) => {
      // position : moyenne pondérée par le nombre de commandes
      const lat = g.villes.reduce((s, v) => s + v.lat * v.n, 0) / g.n;
      const lng = g.villes.reduce((s, v) => s + v.lng * v.n, 0) / g.n;
      const m = L.marker([lat, lng], { icon: iconPour(g.n), zIndexOffset: g.n * 10 }).addTo(calque);
      const pop = document.createElement("div");
      const b = document.createElement("b"); b.style.color = "#D4AF37";
      b.textContent = g.n > 1 ? g.n + " commandes" : "Commande";
      pop.appendChild(b);
      g.villes.sort((x, y) => y.n - x.n).forEach((v) => {
        pop.appendChild(document.createElement("br"));
        pop.appendChild(document.createTextNode(v.label + (g.villes.length > 1 ? " · " + v.n : "")));
      });
      m.bindPopup(pop);
      // clic sur un regroupement : on zoome dessus pour séparer les villes
      if (g.villes.length > 1) m.on("click", () => {
        const b2 = L.latLngBounds(g.villes.map((v) => [v.lat, v.lng]));
        if (map.getZoom() < 13) { map.closePopup(); map.fitBounds(b2.pad(0.6), { maxZoom: map.getZoom() + 3 }); }
      });
    });
  };
  map.on("zoomend", dessiner);

  const coords = villes.map((v) => [v.lat, v.lng]);
  const cadrer = () => {
    map.invalidateSize();
    if (coords.length === 1) map.setView(coords[0], 10);
    else if (coords.length > 1) map.fitBounds(coords, { padding: [50, 50], maxZoom: 9 });
    dessiner();
  };
  cadrer();
  addEventListener("resize", () => { clearTimeout(cadrer.t); cadrer.t = setTimeout(cadrer, 200); });
})();
